import { render, staticRenderFns } from "./CoachingCoreData.vue?vue&type=template&id=5f21d5f6&scoped=true"
import script from "./CoachingCoreData.vue?vue&type=script&lang=js"
export * from "./CoachingCoreData.vue?vue&type=script&lang=js"
import style0 from "./CoachingCoreData.vue?vue&type=style&index=0&id=5f21d5f6&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f21d5f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f21d5f6')) {
      api.createRecord('5f21d5f6', component.options)
    } else {
      api.reload('5f21d5f6', component.options)
    }
    module.hot.accept("./CoachingCoreData.vue?vue&type=template&id=5f21d5f6&scoped=true", function () {
      api.rerender('5f21d5f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/PsychologicalMonthReport/components/PsychologicalTeachersUse/components/CoachingCoreData.vue"
export default component.exports